import { render, staticRenderFns } from "./normal-dialog.vue?vue&type=template&id=2bb922d8&scoped=true"
import script from "./normal-dialog.vue?vue&type=script&lang=js"
export * from "./normal-dialog.vue?vue&type=script&lang=js"
import style0 from "./normal-dialog.vue?vue&type=style&index=0&id=2bb922d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb922d8",
  null
  
)

export default component.exports